import { render, staticRenderFns } from "./devicewaring.vue?vue&type=template&id=12833212&"
import script from "./devicewaring.vue?vue&type=script&lang=ts&"
export * from "./devicewaring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "devicewaring.vue"
export default component.exports